import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const rbacRoleEntity: Entity = {
  model: model,
  repository: repository,
}

export default rbacRoleEntity
